import { GlobalStyles } from './GlobalStyles';
import { ThemeProvider } from './ThemeProvider';
import { PropagationProvider } from './PropagationProvider';
import { ToastProvider } from '../Toast/ToastContext';
import { LazyMotion } from 'framer-motion';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const loadAnimationFeaturesWithRetry = (retries = 2) => import( /* webpackChunkName: "framer-motion-animation-features" */
'./animation-features.ts').then(res => res.default).catch(error => {
  if (retries > 0) {
    return loadAnimationFeaturesWithRetry(retries - 1);
  } else {
    throw error;
  }
});
const loadAnimationFeatures = () => loadAnimationFeaturesWithRetry(0);
const shouldRenderToastProvider = () => {
  // If inside an iframe and the iframe is not a Storybook iframe, don't render the ToastProvider
  if (window !== window.top) {
    try {
      const isStorybookIframe = window.parent.document.querySelector('iframe[data-is-storybook="true"]');
      return isStorybookIframe !== null;
    } catch (error) {
      // Default to false in case of security restrictions
      return false;
    }
  }

  // Default to rendering the ToastProvider when not in an iframe
  return true;
};
const MaybeLazyMotion = ({
  children,
  enable,
  retry
}) => enable ? /*#__PURE__*/_jsx(LazyMotion, {
  features: retry ? loadAnimationFeaturesWithRetry : loadAnimationFeatures,
  strict: true,
  children: children
}) : /*#__PURE__*/_jsx(_Fragment, {
  children: children
});
export const AppProvider = ({
  themeName = 'classic',
  themeMode = 'light',
  applyGlobalStyles = true,
  continuePropagation = false,
  children,
  toast = {
    autoClose: true
  },
  enableAnimationFeatures = true,
  unstable_retryLazyMotionDynamicImport = true
}) => {
  return /*#__PURE__*/_jsx(ThemeProvider, {
    themeName: themeName,
    themeMode: themeMode,
    children: /*#__PURE__*/_jsx(MaybeLazyMotion, {
      retry: unstable_retryLazyMotionDynamicImport,
      enable: enableAnimationFeatures,
      children: /*#__PURE__*/_jsxs(PropagationProvider, {
        continuePropagation: continuePropagation,
        children: [applyGlobalStyles ? /*#__PURE__*/_jsx(GlobalStyles, {}) : null, shouldRenderToastProvider() ? /*#__PURE__*/_jsx(ToastProvider, Object.assign({}, toast, {
          children: children
        })) : children]
      })
    })
  });
};